import { gql } from '@apollo/client';

const schema = {
  paymentType: {
    name: 'paymentType',
    serviceName: 'auth',
    query: gql`
      query paymentType($shop_id: String) {
        paymentType(shop_id: $shop_id) {
          data {
            id
            title
          }
        }
      }
    `,
  },
  changePayment: {
    name: 'updateOrder',
    serviceName: 'auth',
    query: gql`
      mutation updateOrder($ids: [String]!, $payment_type_id: String) {
        updateOrder(ids: $ids, payment_type_id: $payment_type_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
